import { Button } from "@/components/ui/button/button";

import { useUpdateButton } from "./hooks/use-update-button";

export const HeaderUpdateButton = () => {
	const { isValid, onUpdate } = useUpdateButton();

	return (
		<Button variant={isValid ? "outline" : "disabled"} size={"xl"} onClick={onUpdate}>
			公開せずに保存
		</Button>
	);
};
